import React from "react"
import {
  arrowDownRight,
  info,
  arrowTopRight,
  infoBlackIcon,
  pdfIcon,
  Clock,
  calendar
} from "../../images"
import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { http } from "utils/http"
import BottomBar from "../BottomBar/bottombar"
import _ from "lodash"
import momentZone from "moment-timezone"
import { toast } from "react-toastify"
import moment from "moment"
import { RootState } from "store/store"
import { apiEndPoints } from "constants/apiEndpoints"
import { useTranslation } from "react-i18next"

const Summary = () => {
  const { t } = useTranslation()
  const [showTimeZone, setShowTimeZone] = useState("")
  const [showTime, setShowTime] = useState("")
  const [showDate, setShowDate] = useState("")
  const [checkInTime, setcheckInTime] = useState("")
  const [checkOutTime, setcheckOutTime] = useState("")
  const [diffTIme, setDiffTIme] = useState("")
  const dispatch = useDispatch()
  const matchingVisitDetails = useSelector(
    (state: RootState) =>
      state.appointmentReducer.appointment?.matchingVisitDetails
  )
  const visitObj = useSelector(
    (state: RootState) => state.visitReducer.visit?.visit
  )
  const visitId = matchingVisitDetails?.id || visitObj?.visit?.id

  const visitSummaryObj = useSelector(
    (state: RootState) =>
      state.visitSummaryReducer?.visitsummary[0]?.visitSummary
  )

  const Summary = [visitSummaryObj?.outbound, visitSummaryObj?.inbound]
  const visitSummar = {
    inbound: visitSummaryObj?.inbound,
    outbound: visitSummaryObj?.outbound
  }

  const visitSummary = Summary.filter(function (el) {
    return el != null
  })

  useEffect(() => {
    http
      .post(
        `${apiEndPoints.fetchSummary}`,
        {
          visitId: visitId
        },
        {}
      )
      .then(response => {
        dispatch({
          type: "SET_VISIT_SUMMARY",
          payload: [
            {
              visitSummary: response.data.data
            }
          ]
        })
      })
      .catch(err => {
        toast.error(err.response.data.error)
      })
  }, [])

  useEffect(() => {
    if (!_.isEmpty(visitSummaryObj)) {
      const timeZone =
        visitSummaryObj?.outbound?.timezone ||
        visitSummaryObj?.inbound?.timezone
      const offset =
        visitSummaryObj?.outbound?.timezone?.offset ||
        visitSummaryObj?.inbound?.timezone?.offset
      setShowTimeZone(timeZone.name)
      const offsetDate = momentZone(
        visitSummaryObj?.appointmentType == "outbound"
          ? visitSummaryObj?.outbound?.appointmentTime
          : visitSummaryObj?.inbound?.appointmentTime
      ).utcOffset(offset / 3600)
      const showDate = `${offsetDate.format("dddd")}, ${offsetDate.format(
        "MMM DD"
      )}`
      const showTime = `${offsetDate.format("LT")}`
      setShowDate(showDate)
      setShowTime(showTime)
      visitSummaryObj.events.map((item: any) => {
        const offsetDate = momentZone(item.occurredAt).utcOffset(offset / 3600)
        if (item.type == "check-in") {
          setcheckInTime(
            `${offsetDate.format("DD MMM YYYY")}, ${offsetDate.format("LT")} ${
              timeZone.name
            }`
          )
        } else if (item.type == "check-out") {
          setcheckOutTime(
            `${offsetDate.format("DD MMM YYYY")}, ${offsetDate.format("LT")} ${
              timeZone.name
            }`
          )
        } else {
        }
      })
      let startTime = moment(
        visitSummaryObj.events[0].occurredAt,
        "DD-MM-YYYY hh:mm:ss"
      )
      let endTime = moment(
        visitSummaryObj.events[1].occurredAt,
        "DD-MM-YYYY hh:mm:ss"
      )
      let hoursDiff = endTime.diff(startTime, "hours")
      let minutesDiff = endTime.diff(startTime, "minutes")
      setDiffTIme(
        `${
          hoursDiff > 0
            ? `${hoursDiff < 10 ? `0${hoursDiff}` : hoursDiff}h`
            : ""
        } ${
          minutesDiff > 0
            ? `${minutesDiff < 10 ? `0${minutesDiff}` : minutesDiff}m`
            : ""
        }`
      )
    }
  }, [])
  return (
    <>
      {!_.isEmpty(visitSummaryObj) && (
        <div className={`container`}>
          <div className="appointment-details-info">
            <div className="card">
              <div className="rectangle">
                <img
                  className="appointment-details-info-img"
                  src={infoBlackIcon}
                  alt="info"
                />
                <div className="appointment-details-info-text">
                  {t("visit_summary")}
                </div>
              </div>
              <div className="appointment-type">
                <div className="appointment-type-text">
                  {visitSummaryObj.appointmentType.split("_")[0]}
                </div>
              </div>
              <div className="line"></div>
              <div className="appointment-date-time">
                <img
                  className="appointment-date-time-img"
                  src={calendar}
                  alt="calendar"
                />
                <div className="appointment-date-time-text">
                  <div className="date-day">{showDate}</div>
                  <div className="date-time">{`${showTime} ${showTimeZone}`}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="accord-container">
            {summaryDetails({
              header: "Visit Details",
              icon: "Clock",
              buttonText: "",
              trailerType: "",
              visit: [
                {
                  key: "Check-In",
                  value: checkInTime || "--"
                },
                {
                  key: "Delivery Time",
                  value: "--"
                },
                {
                  key: "Pick-up Time",
                  value: "--"
                },
                {
                  key: "Check-Out",
                  value: checkOutTime || "--"
                },
                {
                  key: "Time Spent on Site",
                  value: diffTIme || "--"
                }
              ],
              documentUrl: ""
            })}
            {Object.entries(visitSummar).map((details: any) => {
              if (details[1] != null) {
                let offset = details[1].timezone.offset
                let timeZoneName = details[1].timezone.name
                const offsetDate = momentZone(
                  details[1].appointmentTime
                ).utcOffset(offset / 3600)
                let carrierName = details[1].equipment.carrier.name
                if (details[1].equipment.carrier.scac !== "") {
                  carrierName = `${details[1].equipment.carrier.name} [ ${details[1].equipment.carrier.scac}]`
                }
                var AppointmentTime = ""
                if (details[1].appointmentTime) {
                  AppointmentTime = `${offsetDate.format(
                    "DD MMM YYYY"
                  )}, ${offsetDate.format("LT")} ${showTimeZone}`
                }

                return summaryDetails({
                  header: details[0],
                  trailerType: details[1].trailerType,
                  documentUrl: details[1]?.edocs?.documentUrl,
                  buttonText:
                    details[0] == "inbound" ? "View ePOD" : "View ePOP",
                  icon:
                    details[0] == "inbound"
                      ? "arrowDownRight"
                      : "arrowTopRight",
                  visit: [
                    {
                      key: "Reference Number",
                      value: details[1].referenceNumber || "NA"
                    },
                    {
                      key: "Appointment Time",
                      value: AppointmentTime || "NA"
                    },
                    {
                      key: "Equipment Type",
                      value: details[1].equipment.type || "NA"
                    },
                    {
                      key: "Equipment ID",
                      value: details[1].equipment.id || "NA"
                    },
                    {
                      key: "Equipment Carrier",
                      value: carrierName || "NA"
                    }
                  ]
                })
              }
            })}
          </div>
          <div
            className="warning-info warning-info-driver"
            style={{ marginBottom: "16px" }}
          >
            <img className="warning-info-img" src={info} alt="info" />
            <div className="warning-info-text">
              <p className="margin-top">{t("can_view_page_anytime")}</p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

interface summaryDetailProps {
  header: string
  icon: string
  trailerType: string
  buttonText: string
  visit: any
  documentUrl: string
}

const summaryDetails = (props: summaryDetailProps) => {
  const initiateAction = (item: any) => {
    if (item) {
      window.open(item)
    }
  }
  return (
    <>
      <div className="accord-header" style={{ position: "relative" }}>
        <img
          className="accord-header-image"
          src={
            props.icon === "arrowDownRight"
              ? arrowDownRight
              : props.icon === "arrowTopRight"
              ? arrowTopRight
              : Clock
          }
          alt={props.icon}
        />
        <div className="accord-header-text" style={{ width: "300px" }}>
          {props.header}
        </div>
        {props.trailerType != "" && (
          <div className="trailer-type">
            <span className="trailer-type-text">{props.trailerType}</span>
          </div>
        )}
      </div>
      <div>
        {props.visit.map((item: any) => {
          return (
            <div className="accord-items" key={item.key}>
              <div className="accord-item-key">{item.key}</div>
              <div className="accord-item-value">{item.value}</div>
            </div>
          )
        })}
      </div>
      {props.buttonText != "" && (
        <div className="accord-button">
          <BottomBar
            className="whiteBorderedBtn"
            buttonDisplay={false}
            onClick={() => initiateAction(props.documentUrl)}
            disabled={false}
            text={props.buttonText}
            startIcon={true ? <img src={pdfIcon} alt="pdfIcon" /> : null}
          />
        </div>
      )}
    </>
  )
}
export default Summary
